<template>
  <div class="picture-content">
    <base-img-viewer>
      <div class="content-row">
        <base-img-base
          class="picture-item"
          :height="'60px'"
          style="margin-right:10px; min-width: 150px;"
          ref="headImg" :src="plate"
          :alt="'车牌图'"></base-img-base>
        <div
          class="plate-text plate"
          :style="{backgroundColor:_plateColor,color:plateNumberColor,fontSize:fontSize,}">
          {{plateNumberText}}
        </div>
      </div>
      <div class="content-row">
        <base-img-base
          class="picture-item"
          :height="'200px'"
          style="margin-right: 10px"
          ref="headImg" :src="head"
          :alt="'车头图'"></base-img-base>
        <base-img-base
          class="picture-item"
          :height="'200px'"
          ref="tailImg" :src="tail"
          :alt="'车尾图'"></base-img-base>
      </div>
      <div class="content-row">
        <base-img-base
          class="picture-item"
          :height="'300px'"
          ref="sideImg" :src="side"
          :alt="'车身图'"></base-img-base>
      </div>
    </base-img-viewer>
  </div>
</template>
<style scoped lang="scss">
  // 图片容器
  .picture-content {
    .content-row {
      display: flex;
      margin-bottom: 10px;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      padding-top: 10px;

      .picture-item {
        flex: 1;
        background: #061e2e;
        margin-bottom: 10px
      }

      .plate-text {
        flex: 1;
        min-width: 150px;
        background: #061e2e;
        color: #999;
        margin-bottom: 10px
      }
    }
  }

  // 车牌显示
  .plate {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
  }

</style>

<!--☯js-->
<script>
  let life = {}; let event = {}; let watch = {}
  import * as modelJS from '../../../../../../src/business-components/page-picture-content/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  const methodsSource = {}
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-business-page-picture-content')
  export default {
    name: 'business-page-picture-content', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'business-page-picture-content': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../base-components/account-info/index.vue').default,
       'base-back': require('./../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../base-components/empty/index.vue').default,
       'base-export': require('./../../base-components/export/index.vue').default,
       'base-filter': require('./../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>